import type { GameState } from '../types';
import { ROWS } from './constants';

const SLOT_VALUE = 50;

export type Grade = 'FINAL GIRL' | 'SURVIVOR' | 'WALKING WOUNDED' | 'FRESH MEAT';

// Maximum possible: solving on the first guess uses 1 slot, leaving (ROWS) of
// the slot budget intact. Exposed for the modal's `score / MAX_SCORE` display.
export const MAX_SCORE = ROWS * SLOT_VALUE;

// Each unused row counts; the winning row counts too. A drained row burns a
// slot just like a wrong guess, so no separate penalty is needed — the drip
// IS the penalty.
export function totalScore(state: GameState): number {
  if (state.status !== 'won') return 0;
  if (state.chillMode) return 0;
  const used = state.guesses.length;
  return (ROWS - used + 1) * SLOT_VALUE;
}

// Tiers calibrated to the 5-row max of 250. Clean solves land on each
// threshold: solve-in-2 = 200 (FINAL GIRL), solve-in-3 = 150 (SURVIVOR),
// solve-in-4 = 100 (WALKING WOUNDED).
export function gradeForScore(score: number, won: boolean): Grade {
  if (!won) return 'FRESH MEAT';
  if (score >= 200) return 'FINAL GIRL';
  if (score >= 150) return 'SURVIVOR';
  if (score >= 80) return 'WALKING WOUNDED';
  return 'FRESH MEAT';
}
